// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.searchPeopleInput_wT4QW {
	position: relative;
	border: none;
	outline: none;
}

.locationIconDropdown_bxLPU {
	display: flex;
	color: var(--_3c3a3a-color);
	margin-bottom: 1px;
}

.arrowIcon_Vb6kF {
	width: 0;
	height: 0;
	border-left: 4px solid transparent;
	border-right: 4px solid transparent;
	border-top: 4px solid #666;
	margin-left: 8px;
	transition: transform 0.2s ease-in-out;
}

.panelMenu_hIuZT {
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;

	.button_iI9B8 {
		background: transparent;
		color: var(--_10a37f-background);
		padding: 2px;
		border-radius: 3px;
		display: inline-flex;
		width: fit-content;
		justify-content: flex-start;
		gap: 0px;
		position: relative;
		font-size: 18px;
		font-weight: 600;
		align-items: center;
		margin-bottom: 6px;
		cursor: pointer;
		transition: all 0.2s ease-in-out;

		&:hover {
			background-color: var(--fa-background);
		}

		svg {
			min-width: 16px;
			min-height: 16px;
			color: var(--_10a37f-background);
		}

		.arrow_W0y6U {
			margin-left: auto;
		}

		ul {
			position: absolute;
			display: inline-flex;
			flex-direction: column;
			left: 0px;
			top: 54px;
			border-radius: 10px;
			overflow: hidden;
			box-shadow: 0px 0px 10px -6px var(--_3c3a3a-color);
			padding: 4px;

			li {
				padding: 6px 12px;
				background: var(--_16c0982e-background);
				cursor: pointer;
				border-radius: 8px;

				&:hover {
					background: var(--_16c0982e-background);
				}
			}
		}
	}

	.date_OQrTE {
		display: flex;
		align-items: center;
		gap: 2px;
		justify-content: space-between;

		b {
			font-size: 12px;
			font-weight: 600;
		}

		div {
			display: flex;
			align-items: center;
			gap: 10px;

			button {
				border: none;
				transition:
					background 0.2s ease-in-out,
					transform 0.1s ease-in-out;
				cursor: pointer;
				-webkit-user-select: none;
				        user-select: none;
				padding: 3px;
				/* background: var(--_16c0982e-background); */
				color: var(--_10a37f-background);
				border-radius: 6px;

				&:hover {
					background: var(--fa-background);
					transform: scale(1.05);
				}

				&:active {
					background: var(--_16c098-color);
					transform: scale(0.95);
				}

				svg {
					width: 8px;
					height: 8px;
				}
			}
		}
	}

	.miniMap_krpj5 {
		width: 100%;
		background: var(--fa-background);
		border-radius: 10px;
		padding: 2px;

		table {
			width: 100%;

			td,
			th {
				width: calc(100vh / 7);
				text-align: center;
				font-size: 12px;
				height: 30px;
			}
		}
	}

	.hour_ZvPmW {
		font-size: 12px;
		display: flex;
		align-items: center;
		gap: 5px;
		justify-content: space-between;

		div {
			display: flex;
			align-items: center;

			span {
				min-width: 53px;
				font-size: 11px;
				color: var(--_3c3a3a-color);
			}

			.sun_u6xLp {
				min-width: 13px;
				min-height: 13px;
				width: 13px;
				border-radius: 3px;
				background: var(--_10a37f-background);
			}
		}
	}

	.createCalendarButton_MvoWw {
		display: flex;
		color: var(--_3c3a3a-color);
		font-size: 14px;
		cursor: pointer;
		-webkit-user-select: none;
		        user-select: none;
	}

	.meeting_Flz68 {
		position: relative;
		display: flex;
		align-items: flex-start;
		flex-direction: column;
		margin-bottom: 4px;
		gap: 4px;
		width: 100%;

		b {
			font-size: 13px;
			font-weight: 500;
		}

		.input_JgSTW {
			display: flex;
			align-items: center;
			gap: 4px;
			background: var(--border-color);
			border-radius: 6px;
			padding: 4px 0px;

			svg {
				min-height: 16px;
				min-width: 16px;
				width: 16px;
			}

			input {
				width: 100%;
				font-size: 16px;
				background: transparent;
			}
		}
	}


	.stats_gv2YK {
		display: flex;
		flex-direction: column;
		gap: 2px;

		label {
			font-size: 14px;
			font-weight: 600;
		}

		.progress_THLL4 {
			border: 1px solid var(--border-color);
			height: 30px;
			border-radius: 10px;
			padding: 4px;

			.bar_SQmEf {
				width: 40%;
				height: 100%;
				background: var(--_16c0982e-background);
				border-radius: 10px;

				div {}
			}
		}
	}

	.buttonInfo_sNZWP {
		button {
			cursor: pointer;
			display: inline-flex;
			align-items: center;
			border: 1px solid var(--_10a37f-background);
			padding: 4px 10px;
			gap: 4px;
			border-radius: 6px;
			color: var(--_10a37f-background);
			background: transparent;

			svg {
				width: 16px;
				min-width: 16px;
				min-height: 16px;
			}
		}
	}

	.calendars_zHbo4 {
		display: inline-flex;
		align-items: center;
		justify-content: space-between;

		label {
			font-size: 17px;
			margin-bottom: 2px;
			color: var(--_3c3a3a-color);
		}

		svg {
			width: 26px;
			height: 26px;
		}
	}

	.calendarsList_nQcrQ {
		display: inline-flex;
		flex-direction: column;
		gap: 4px;
		padding-left: 0px;
		margin: 0px;

		li {
			display: inline-flex;
			align-items: center;
			gap: 5px;

			.dot_BmtRD {
				min-width: 12px;
				min-height: 12px;
				border-radius: 50%;
				background: var(--_16c0982e-background);
			}

			span {
				font-size: 14px;
				font-weight: 500;
			}

			svg {
				width: 26px;
				height: 26px;
			}
		}
	}
}


.miniCalendarTable_CV4Rl {
	border-spacing: 3px;
	z-index: 400000;
}

.miniCalendarTbody_Ii6i_ {}

.miniCalendarTr_wVrGF {}

.miniCalendarTd_WLPBk {
	padding: 2px;
	position: relative;
}

.dayCell_zUIuo {

	border-radius: 50%;
	color: var(--_3c3a3a-color);
	cursor: pointer;
	width: 20px !important;
	height: 20px !important;
	min-width: 20px !important;
	min-height: 20px !important;
	padding: 3px !important;
	display: flex;
	-webkit-user-select: none;
	        user-select: none;
	align-items: center;
	justify-content: center;
	font-size: 12px;

	&:hover {
		background: var(--label-color);
	}
}

.buttonWrapper_k8Ovo {
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	right: 2px;
	bottom: -2px;
}

.selectedDayCell_HlCdT {
	background: var(--_16c098-background);
	border-radius: 5px;
	cursor: pointer;
	color: var(--white-color);
	width: 25px !important;
	height: 25px !important;
	min-width: 25px !important;
	min-height: 25px !important;
	padding: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;
	font-weight: 600;

	&:hover {
		opacity: 0.8;
		background: var(--_16c098-background);
	}
}

.currentDayCell_ATDn_ {
	background: var(--e4fff9-background);
	border-radius: 6px;
	color: var(--16C097-fille);
	cursor: pointer;
	width: 25px !important;
	height: 25px !important;
	min-width: 25px !important;
	min-height: 25px !important;
	padding: 3px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 12px;

	&:hover {
		background: var(--_16c098-background);
	}
}

.dayInitial_Z0w5e {
	color: var(--_10a37f-background);
}

.eventDotsContainer_E3BZG {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: row;
	position: absolute;
	top: -2px;
	right: -2px;
}

.eventDot_njmbb {
	width: 8px;
	height: 8px;
	margin-top: 2px;
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 0px;
	font-size: 7px;
	color: var(--white-color);
	border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/event.module.css"],"names":[],"mappings":";;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,aAAa;CACb,2BAA2B;CAC3B,kBAAkB;AACnB;;AAEA;CACC,QAAQ;CACR,SAAS;CACT,kCAAkC;CAClC,mCAAmC;CACnC,0BAA0B;CAC1B,gBAAgB;CAChB,sCAAsC;AACvC;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,WAAW;;CAEX;EACC,uBAAuB;EACvB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B,QAAQ;EACR,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gCAAgC;;EAEhC;GACC,sCAAsC;EACvC;;EAEA;GACC,eAAe;GACf,gBAAgB;GAChB,gCAAgC;EACjC;;EAEA;GACC,iBAAiB;EAClB;;EAEA;GACC,kBAAkB;GAClB,oBAAoB;GACpB,sBAAsB;GACtB,SAAS;GACT,SAAS;GACT,mBAAmB;GACnB,gBAAgB;GAChB,kDAAkD;GAClD,YAAY;;GAEZ;IACC,iBAAiB;IACjB,uCAAuC;IACvC,eAAe;IACf,kBAAkB;;IAElB;KACC,uCAAuC;IACxC;GACD;EACD;CACD;;CAEA;EACC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;;EAE9B;GACC,eAAe;GACf,gBAAgB;EACjB;;EAEA;GACC,aAAa;GACb,mBAAmB;GACnB,SAAS;;GAET;IACC,YAAY;IACZ;;+BAE2B;IAC3B,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;IACjB,YAAY;IACZ,6CAA6C;IAC7C,gCAAgC;IAChC,kBAAkB;;IAElB;KACC,gCAAgC;KAChC,sBAAsB;IACvB;;IAEA;KACC,gCAAgC;KAChC,sBAAsB;IACvB;;IAEA;KACC,UAAU;KACV,WAAW;IACZ;GACD;EACD;CACD;;CAEA;EACC,WAAW;EACX,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;;EAEZ;GACC,WAAW;;GAEX;;IAEC,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,YAAY;GACb;EACD;CACD;;CAEA;EACC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;;EAE9B;GACC,aAAa;GACb,mBAAmB;;GAEnB;IACC,eAAe;IACf,eAAe;IACf,2BAA2B;GAC5B;;GAEA;IACC,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,qCAAqC;GACtC;EACD;CACD;;CAEA;EACC,aAAa;EACb,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;CAClB;;CAEA;EACC,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,WAAW;;EAEX;GACC,eAAe;GACf,gBAAgB;EACjB;;EAEA;GACC,aAAa;GACb,mBAAmB;GACnB,QAAQ;GACR,+BAA+B;GAC/B,kBAAkB;GAClB,gBAAgB;;GAEhB;IACC,gBAAgB;IAChB,eAAe;IACf,WAAW;GACZ;;GAEA;IACC,WAAW;IACX,eAAe;IACf,uBAAuB;GACxB;EACD;CACD;;;CAGA;EACC,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;GACC,eAAe;GACf,gBAAgB;EACjB;;EAEA;GACC,qCAAqC;GACrC,YAAY;GACZ,mBAAmB;GACnB,YAAY;;GAEZ;IACC,UAAU;IACV,YAAY;IACZ,uCAAuC;IACvC,mBAAmB;;IAEnB,KAAK;GACN;EACD;CACD;;CAEA;EACC;GACC,eAAe;GACf,oBAAoB;GACpB,mBAAmB;GACnB,2CAA2C;GAC3C,iBAAiB;GACjB,QAAQ;GACR,kBAAkB;GAClB,gCAAgC;GAChC,uBAAuB;;GAEvB;IACC,WAAW;IACX,eAAe;IACf,gBAAgB;GACjB;EACD;CACD;;CAEA;EACC,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;;EAE9B;GACC,eAAe;GACf,kBAAkB;GAClB,2BAA2B;EAC5B;;EAEA;GACC,WAAW;GACX,YAAY;EACb;CACD;;CAEA;EACC,oBAAoB;EACpB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,WAAW;;EAEX;GACC,oBAAoB;GACpB,mBAAmB;GACnB,QAAQ;;GAER;IACC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;GACxC;;GAEA;IACC,eAAe;IACf,gBAAgB;GACjB;;GAEA;IACC,WAAW;IACX,YAAY;GACb;EACD;CACD;AACD;;;AAGA;CACC,mBAAmB;CACnB,eAAe;AAChB;;AAEA,0BAAoB;;AAEpB,uBAAiB;;AAEjB;CACC,YAAY;CACZ,kBAAkB;AACnB;;AAEA;;CAEC,kBAAkB;CAClB,2BAA2B;CAC3B,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,uBAAuB;CACvB,aAAa;CACb,yBAAiB;SAAjB,iBAAiB;CACjB,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;;CAEf;EACC,8BAA8B;CAC/B;AACD;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,kBAAkB;CAClB,UAAU;CACV,YAAY;AACb;;AAEA;CACC,qCAAqC;CACrC,kBAAkB;CAClB,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;CACf,gBAAgB;;CAEhB;EACC,YAAY;EACZ,qCAAqC;CACtC;AACD;;AAEA;CACC,oCAAoC;CACpC,kBAAkB;CAClB,0BAA0B;CAC1B,eAAe;CACf,sBAAsB;CACtB,uBAAuB;CACvB,0BAA0B;CAC1B,2BAA2B;CAC3B,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,eAAe;;CAEf;EACC,qCAAqC;CACtC;AACD;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,mBAAmB;CACnB,kBAAkB;CAClB,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,UAAU;CACV,WAAW;CACX,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,cAAc;CACd,yBAAyB;CACzB,kBAAkB;AACnB","sourcesContent":["\n\n.searchPeopleInput {\n\tposition: relative;\n\tborder: none;\n\toutline: none;\n}\n\n.locationIconDropdown {\n\tdisplay: flex;\n\tcolor: var(--_3c3a3a-color);\n\tmargin-bottom: 1px;\n}\n\n.arrowIcon {\n\twidth: 0;\n\theight: 0;\n\tborder-left: 4px solid transparent;\n\tborder-right: 4px solid transparent;\n\tborder-top: 4px solid #666;\n\tmargin-left: 8px;\n\ttransition: transform 0.2s ease-in-out;\n}\n\n.panelMenu {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 10px;\n\twidth: 100%;\n\n\t.button {\n\t\tbackground: transparent;\n\t\tcolor: var(--_10a37f-background);\n\t\tpadding: 2px;\n\t\tborder-radius: 3px;\n\t\tdisplay: inline-flex;\n\t\twidth: fit-content;\n\t\tjustify-content: flex-start;\n\t\tgap: 0px;\n\t\tposition: relative;\n\t\tfont-size: 18px;\n\t\tfont-weight: 600;\n\t\talign-items: center;\n\t\tmargin-bottom: 6px;\n\t\tcursor: pointer;\n\t\ttransition: all 0.2s ease-in-out;\n\n\t\t&:hover {\n\t\t\tbackground-color: var(--fa-background);\n\t\t}\n\n\t\tsvg {\n\t\t\tmin-width: 16px;\n\t\t\tmin-height: 16px;\n\t\t\tcolor: var(--_10a37f-background);\n\t\t}\n\n\t\t.arrow {\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\tul {\n\t\t\tposition: absolute;\n\t\t\tdisplay: inline-flex;\n\t\t\tflex-direction: column;\n\t\t\tleft: 0px;\n\t\t\ttop: 54px;\n\t\t\tborder-radius: 10px;\n\t\t\toverflow: hidden;\n\t\t\tbox-shadow: 0px 0px 10px -6px var(--_3c3a3a-color);\n\t\t\tpadding: 4px;\n\n\t\t\tli {\n\t\t\t\tpadding: 6px 12px;\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tcursor: pointer;\n\t\t\t\tborder-radius: 8px;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.date {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 2px;\n\t\tjustify-content: space-between;\n\n\t\tb {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: 600;\n\t\t}\n\n\t\tdiv {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 10px;\n\n\t\t\tbutton {\n\t\t\t\tborder: none;\n\t\t\t\ttransition:\n\t\t\t\t\tbackground 0.2s ease-in-out,\n\t\t\t\t\ttransform 0.1s ease-in-out;\n\t\t\t\tcursor: pointer;\n\t\t\t\tuser-select: none;\n\t\t\t\tpadding: 3px;\n\t\t\t\t/* background: var(--_16c0982e-background); */\n\t\t\t\tcolor: var(--_10a37f-background);\n\t\t\t\tborder-radius: 6px;\n\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: var(--fa-background);\n\t\t\t\t\ttransform: scale(1.05);\n\t\t\t\t}\n\n\t\t\t\t&:active {\n\t\t\t\t\tbackground: var(--_16c098-color);\n\t\t\t\t\ttransform: scale(0.95);\n\t\t\t\t}\n\n\t\t\t\tsvg {\n\t\t\t\t\twidth: 8px;\n\t\t\t\t\theight: 8px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t.miniMap {\n\t\twidth: 100%;\n\t\tbackground: var(--fa-background);\n\t\tborder-radius: 10px;\n\t\tpadding: 2px;\n\n\t\ttable {\n\t\t\twidth: 100%;\n\n\t\t\ttd,\n\t\t\tth {\n\t\t\t\twidth: calc(100vh / 7);\n\t\t\t\ttext-align: center;\n\t\t\t\tfont-size: 12px;\n\t\t\t\theight: 30px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.hour {\n\t\tfont-size: 12px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 5px;\n\t\tjustify-content: space-between;\n\n\t\tdiv {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\tspan {\n\t\t\t\tmin-width: 53px;\n\t\t\t\tfont-size: 11px;\n\t\t\t\tcolor: var(--_3c3a3a-color);\n\t\t\t}\n\n\t\t\t.sun {\n\t\t\t\tmin-width: 13px;\n\t\t\t\tmin-height: 13px;\n\t\t\t\twidth: 13px;\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tbackground: var(--_10a37f-background);\n\t\t\t}\n\t\t}\n\t}\n\n\t.createCalendarButton {\n\t\tdisplay: flex;\n\t\tcolor: var(--_3c3a3a-color);\n\t\tfont-size: 14px;\n\t\tcursor: pointer;\n\t\tuser-select: none;\n\t}\n\n\t.meeting {\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\talign-items: flex-start;\n\t\tflex-direction: column;\n\t\tmargin-bottom: 4px;\n\t\tgap: 4px;\n\t\twidth: 100%;\n\n\t\tb {\n\t\t\tfont-size: 13px;\n\t\t\tfont-weight: 500;\n\t\t}\n\n\t\t.input {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tgap: 4px;\n\t\t\tbackground: var(--border-color);\n\t\t\tborder-radius: 6px;\n\t\t\tpadding: 4px 0px;\n\n\t\t\tsvg {\n\t\t\t\tmin-height: 16px;\n\t\t\t\tmin-width: 16px;\n\t\t\t\twidth: 16px;\n\t\t\t}\n\n\t\t\tinput {\n\t\t\t\twidth: 100%;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tbackground: transparent;\n\t\t\t}\n\t\t}\n\t}\n\n\n\t.stats {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tgap: 2px;\n\n\t\tlabel {\n\t\t\tfont-size: 14px;\n\t\t\tfont-weight: 600;\n\t\t}\n\n\t\t.progress {\n\t\t\tborder: 1px solid var(--border-color);\n\t\t\theight: 30px;\n\t\t\tborder-radius: 10px;\n\t\t\tpadding: 4px;\n\n\t\t\t.bar {\n\t\t\t\twidth: 40%;\n\t\t\t\theight: 100%;\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t\tborder-radius: 10px;\n\n\t\t\t\tdiv {}\n\t\t\t}\n\t\t}\n\t}\n\n\t.buttonInfo {\n\t\tbutton {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tborder: 1px solid var(--_10a37f-background);\n\t\t\tpadding: 4px 10px;\n\t\t\tgap: 4px;\n\t\t\tborder-radius: 6px;\n\t\t\tcolor: var(--_10a37f-background);\n\t\t\tbackground: transparent;\n\n\t\t\tsvg {\n\t\t\t\twidth: 16px;\n\t\t\t\tmin-width: 16px;\n\t\t\t\tmin-height: 16px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.calendars {\n\t\tdisplay: inline-flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\tlabel {\n\t\t\tfont-size: 17px;\n\t\t\tmargin-bottom: 2px;\n\t\t\tcolor: var(--_3c3a3a-color);\n\t\t}\n\n\t\tsvg {\n\t\t\twidth: 26px;\n\t\t\theight: 26px;\n\t\t}\n\t}\n\n\t.calendarsList {\n\t\tdisplay: inline-flex;\n\t\tflex-direction: column;\n\t\tgap: 4px;\n\t\tpadding-left: 0px;\n\t\tmargin: 0px;\n\n\t\tli {\n\t\t\tdisplay: inline-flex;\n\t\t\talign-items: center;\n\t\t\tgap: 5px;\n\n\t\t\t.dot {\n\t\t\t\tmin-width: 12px;\n\t\t\t\tmin-height: 12px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\tbackground: var(--_16c0982e-background);\n\t\t\t}\n\n\t\t\tspan {\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 500;\n\t\t\t}\n\n\t\t\tsvg {\n\t\t\t\twidth: 26px;\n\t\t\t\theight: 26px;\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.miniCalendarTable {\n\tborder-spacing: 3px;\n\tz-index: 400000;\n}\n\n.miniCalendarTbody {}\n\n.miniCalendarTr {}\n\n.miniCalendarTd {\n\tpadding: 2px;\n\tposition: relative;\n}\n\n.dayCell {\n\n\tborder-radius: 50%;\n\tcolor: var(--_3c3a3a-color);\n\tcursor: pointer;\n\twidth: 20px !important;\n\theight: 20px !important;\n\tmin-width: 20px !important;\n\tmin-height: 20px !important;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\tuser-select: none;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 12px;\n\n\t&:hover {\n\t\tbackground: var(--label-color);\n\t}\n}\n\n.buttonWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tposition: absolute;\n\tright: 2px;\n\tbottom: -2px;\n}\n\n.selectedDayCell {\n\tbackground: var(--_16c098-background);\n\tborder-radius: 5px;\n\tcursor: pointer;\n\tcolor: var(--white-color);\n\twidth: 25px !important;\n\theight: 25px !important;\n\tmin-width: 25px !important;\n\tmin-height: 25px !important;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 12px;\n\tfont-weight: 600;\n\n\t&:hover {\n\t\topacity: 0.8;\n\t\tbackground: var(--_16c098-background);\n\t}\n}\n\n.currentDayCell {\n\tbackground: var(--e4fff9-background);\n\tborder-radius: 6px;\n\tcolor: var(--16C097-fille);\n\tcursor: pointer;\n\twidth: 25px !important;\n\theight: 25px !important;\n\tmin-width: 25px !important;\n\tmin-height: 25px !important;\n\tpadding: 3px !important;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 12px;\n\n\t&:hover {\n\t\tbackground: var(--_16c098-background);\n\t}\n}\n\n.dayInitial {\n\tcolor: var(--_10a37f-background);\n}\n\n.eventDotsContainer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-start;\n\tflex-direction: row;\n\tposition: absolute;\n\ttop: -2px;\n\tright: -2px;\n}\n\n.eventDot {\n\twidth: 8px;\n\theight: 8px;\n\tmargin-top: 2px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tpadding-top: 0px;\n\tfont-size: 7px;\n\tcolor: var(--white-color);\n\tborder-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchPeopleInput": `searchPeopleInput_wT4QW`,
	"locationIconDropdown": `locationIconDropdown_bxLPU`,
	"arrowIcon": `arrowIcon_Vb6kF`,
	"panelMenu": `panelMenu_hIuZT`,
	"button": `button_iI9B8`,
	"arrow": `arrow_W0y6U`,
	"date": `date_OQrTE`,
	"miniMap": `miniMap_krpj5`,
	"hour": `hour_ZvPmW`,
	"sun": `sun_u6xLp`,
	"createCalendarButton": `createCalendarButton_MvoWw`,
	"meeting": `meeting_Flz68`,
	"input": `input_JgSTW`,
	"stats": `stats_gv2YK`,
	"progress": `progress_THLL4`,
	"bar": `bar_SQmEf`,
	"buttonInfo": `buttonInfo_sNZWP`,
	"calendars": `calendars_zHbo4`,
	"calendarsList": `calendarsList_nQcrQ`,
	"dot": `dot_BmtRD`,
	"miniCalendarTable": `miniCalendarTable_CV4Rl`,
	"miniCalendarTbody": `miniCalendarTbody_Ii6i_`,
	"miniCalendarTr": `miniCalendarTr_wVrGF`,
	"miniCalendarTd": `miniCalendarTd_WLPBk`,
	"dayCell": `dayCell_zUIuo`,
	"buttonWrapper": `buttonWrapper_k8Ovo`,
	"selectedDayCell": `selectedDayCell_HlCdT`,
	"currentDayCell": `currentDayCell_ATDn_`,
	"dayInitial": `dayInitial_Z0w5e`,
	"eventDotsContainer": `eventDotsContainer_E3BZG`,
	"eventDot": `eventDot_njmbb`
};
export default ___CSS_LOADER_EXPORT___;
